"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pathCase = void 0;
exports.pathCase = {
    id: 13650,
    caseRuns: [
        {
            version: "2.0",
            case_json_id: "PATH-18889",
            case_id: 13650,
            process_instance_id: 18889,
            case_uid: "123",
            process_instance_guid: "bbb178b7-4042-4b19-8fbd-b873adaea4c9",
            case_encounter_id: 12943,
            facility: "HFM",
            case_status: "Manual",
            process_status: "Done",
            primary_process_indicator: true,
            run_type: "prediction",
            source_type: "HL7",
            service_line: "Pathology",
            tenant_code: "BWH",
            tenant_uid: "abb178b7-4042-4b19-8fbd-b873adaea4c9",
            tenant_name: "Brigham & Women's Hospital",
            tenant_timezone: "America/New_York",
            health_system_code: "PHS",
            service_tenant_name: null,
            service_tenant_code: null,
            provider_tenant_name: null,
            provider_tenant_code: null,
            patient_id: 455838,
            patient_name: "BWPathFromPP17755, Demo",
            date_of_birth: "1984-04-10",
            patient_age: null,
            patient_gender: "M",
            admitting_provider_name: "",
            admitting_provider: {
                number: "MRNc9ca4bd020d74c228f8d0cd72e341514",
                issuer: "BWH",
                type: "MRN"
            },
            patient_identifier: {
                number: "MRNc9ca4bd020d74c228f8d0cd72e341514",
                issuer: "BWH",
                type: "MRN"
            },
            visit_number: {
                number: "VISITce6acf9bee124482894eb40c872637b0",
                issuer: "EPIC",
                type: "VISIT_NUMBER"
            },
            account_number: {
                number: "300000000755",
                issuer: null,
                type: null
            },
            patient_class: "O",
            patient_type: null,
            reason_for_visit: null,
            primary_insurance: null,
            primary_insurance_category: null,
            encounter_identifier: {
                number: "Ede78774d3af04aa4affca7436d210306",
                issuer: "CMX",
                type: "BUSINESS_KEY"
            },
            point_of_care: "BWH_MCIRTUM",
            place_of_service: "CMX",
            order_control: null,
            order_number: null,
            order_placer_number: null,
            order_filler_number: {
                number: "Ede78774d3af04aa4affca7436d210306",
                issuer: "EPIC",
                type: "SPECIMEN_NUMBER"
            },
            ordering_provider_name: null,
            ordering_provider_specialty: null,
            ordering_provider_number: null,
            primary_clinical_identifier: {
                number: "Ede78774d3af04aa4affca7436d210306",
                issuer: "EPIC",
                type: "SPECIMEN_NUMBER"
            },
            division: "CMX",
            exam_code: null,
            exam_description: null,
            body_region: null,
            procedure_type: null,
            procedure_type_category: null,
            work_queue_name: null,
            date_of_service: "2022-04-25",
            datetime_of_service: "2022-04-25 00:00:00 EDT",
            exam_date: null,
            exam_datetime: null,
            relevant_clinical_info: null,
            sending_facility: null,
            placer_field_2: null,
            patient_primary_facility: null,
            service: null,
            transaction_id: null,
            result_status: null,
            scheduling_department: null,
            scheduling_department_code: null,
            resource_name: null,
            resource_code: null,
            admission_datetime: null,
            discharge_datetime: null,
            attending_provider_specialty: null,
            attending_provider_name: null,
            attending_provider_number: null,
            billing_location: "CMX",
            billing_area: null,
            billing_provider_specialty: null,
            billing_provider_name: "FOGG, PHINEAS",
            billing_provider_number: {
                number: "424324",
                issuer: "EPIC",
                type: "IDNO"
            },
            billing_provider_assistant_name: null,
            billing_provider_assistant_number: null,
            billing_patient_identifier: null,
            referring_provider_specialty: null,
            referring_provider_name: null,
            referring_provider_number: {
                number: null,
                issuer: null,
                type: null
            },
            performing_provider_specialty: null,
            performing_provider_name: null,
            performing_provider_number: null,
            service_provider_specialty: null,
            service_provider_name: null,
            service_provider_number: null,
            hl7_insurance_plan_id: null,
            hl7_insurance_plan_text: null,
            hl7_insurance_payer_id: null,
            hl7_insurance_payer_name: null,
            hl7_insurance_plan_type: null,
            tenant_insurance_plan_id: null,
            tenant_insurance_plan_text: null,
            tenant_insurance_payer_id: null,
            tenant_insurance_payer_name: null,
            tenant_insurance_payer_number: null,
            tenant_medicare_contractor: null,
            cmx_insurance_plan_text: null,
            cmx_insurance_payer_id: null,
            cmx_mapped_payer_number: null,
            cmx_payer_group_name_property_name: null,
            cmx_payer_category_property_name: null,
            claims_edit_enabled_indicator: null,
            medicare_jurisdiction: null,
            medicare_contractor: null,
            requires_medicaid_cci_edits_indicator: null,
            requires_cms_cci_edits_indicator: null,
            requires_ncd_edits_indicator: null,
            requires_lcd_edits_indicator: null,
            requires_commercial_edits_indicator: null,
            requires_mln_edits_indicator: null,
            requires_article_edits_indicator: null,
            requires_cms_manual_edits_indicator: null,
            requires_transmittal_manual_edits_indicator: null,
            specimen_sources: [],
            scenario: null,
            scenarios: [],
            case_type: null,
            specialty: null,
            grouper: null,
            custom_values: {},
            mappings: [],
            invoices: [
                {
                    type: "CLINICAL",
                    guid: "bbb178b7-4042-4b19-8fbd-b873adaea4b9",
                    patient_type: "",
                    filler_number: {
                        number: "Ede78774d3af04aa4affca7436d210306",
                        issuer: "EPIC",
                        type: "SPECIMEN_NUMBER"
                    },
                    billing_provider_name: "FOGG, PHINEAS",
                    billing_provider_number: {
                        number: "424324",
                        issuer: "EPIC",
                        type: "IDNO"
                    },
                    ordering_provider_name: null,
                    ordering_provider_number: {
                        number: null,
                        issuer: "EPIC",
                        type: "IDNO"
                    },
                    performing_provider_name: null,
                    performing_provider_number: {
                        number: null,
                        issuer: "EPIC",
                        type: "IDNO"
                    },
                    transactions: [
                        {
                            guid: "e28fcbd7-9de3-40ed-a72b-6968cdf1e720",
                            date_of_service: "2022-04-25",
                            datetime_of_service: "2022-04-25 00:00:00 EDT",
                            transaction_type: "CG",
                            transaction_id: 144061,
                            source_transaction_id: "2",
                            transaction_posting_date: "2021-04-20",
                            alt_transaction_description: "FINE NEEDLE ASPIRATION, RIGHT CHEST WALL",
                            department_code: "10030010328",
                            fee_schedule: "5000356",
                            technical_code: {
                                units: 1.0,
                                code: "31000093",
                                used: true,
                                automated: false,
                                sequence_number: 0,
                                evidence: []
                            },
                            modifiers: [],
                            diagnoses: [
                                {
                                    diagnosis_uid: null,
                                    diagnosis_code: "L02.91",
                                    evidence_source_uid: null,
                                    automate: false,
                                    confidence: 0.0,
                                    sequence_number: 1,
                                    type: "ICD10",
                                    evidence: [],
                                    used: true
                                }
                            ]
                        },
                        {
                            guid: "6cb42748-15b6-4f78-8c2f-380f25f776e9",
                            date_of_service: "2022-04-25",
                            datetime_of_service: "2022-04-25 00:00:00 EDT",
                            transaction_type: "CG",
                            transaction_id: 144062,
                            source_transaction_id: "1",
                            transaction_posting_date: "2021-04-20",
                            alt_transaction_description: "FNA Rapid Evaluation (Professional and T",
                            department_code: "10030010328",
                            fee_schedule: "5000356",
                            technical_code: {
                                units: 1.0,
                                code: "31000092",
                                used: true,
                                automated: false,
                                sequence_number: 0,
                                evidence: []
                            },
                            modifiers: [],
                            diagnoses: [
                                {
                                    diagnosis_uid: null,
                                    diagnosis_code: "L02.91",
                                    evidence_source_uid: null,
                                    automate: false,
                                    confidence: 0.0,
                                    sequence_number: 1,
                                    type: "ICD10",
                                    evidence: [],
                                    used: true
                                }
                            ]
                        },
                        {
                            guid: "f86744ef-b04f-4284-874a-786638902335",
                            date_of_service: "2022-04-25",
                            datetime_of_service: "2022-04-25 00:00:00 EDT",
                            transaction_type: "CG",
                            transaction_id: 144060,
                            source_transaction_id: "3",
                            transaction_posting_date: "2021-04-20",
                            alt_transaction_description: "Charge for cytology with cell block",
                            department_code: "10030010328",
                            fee_schedule: "5000356",
                            technical_code: {
                                units: 1.0,
                                code: "31000150",
                                used: true,
                                automated: false,
                                sequence_number: 0,
                                evidence: []
                            },
                            modifiers: [],
                            diagnoses: [
                                {
                                    diagnosis_uid: null,
                                    diagnosis_code: "L02.91",
                                    evidence_source_uid: null,
                                    automate: false,
                                    confidence: 0.0,
                                    sequence_number: 1,
                                    type: "ICD10",
                                    evidence: [],
                                    used: true
                                }
                            ]
                        }
                    ],
                    billing_provider_type: null,
                    ordering_provider_type: null,
                    referring_provider_type: null,
                    performing_provider_type: null
                },
                {
                    type: "ASSEMBLED",
                    guid: "db7aa08d-2374-449f-bfb7-b9d3ff50590d",
                    patient_type: "",
                    filler_number: {
                        number: "Ede78774d3af04aa4affca7436d210306",
                        issuer: "EPIC",
                        type: "SPECIMEN_NUMBER"
                    },
                    billing_provider_name: "FOGG, PHINEAS",
                    billing_provider_number: {
                        number: "424324",
                        issuer: "EPIC",
                        type: "IDNO"
                    },
                    ordering_provider_name: null,
                    ordering_provider_number: {
                        number: null,
                        issuer: "EPIC",
                        type: "IDNO"
                    },
                    performing_provider_name: null,
                    performing_provider_number: {
                        number: null,
                        issuer: "EPIC",
                        type: "IDNO"
                    },
                    transactions: [
                        {
                            guid: "e79a0b75-2290-49e6-a74c-45c12507db1e",
                            date_of_service: "2022-04-25",
                            datetime_of_service: "2022-04-25 00:00:00 EDT",
                            transaction_type: "CG",
                            transaction_id: 144070,
                            source_transaction_id: "3",
                            transaction_posting_date: "2021-04-20",
                            alt_transaction_description: "Charge for cytology with cell block",
                            department_code: "10030010328",
                            fee_schedule: "5000356",
                            technical_code: {
                                units: 1.0,
                                code: "31000150",
                                used: true,
                                automated: false,
                                sequence_number: 0,
                                evidence: []
                            },
                            modifiers: [],
                            diagnoses: [
                                {
                                    diagnosis_uid: null,
                                    diagnosis_code: "L02.91",
                                    evidence_source_uid: null,
                                    automate: false,
                                    confidence: 0.0,
                                    sequence_number: 1,
                                    type: "ICD10",
                                    evidence: [],
                                    used: true
                                }
                            ]
                        },
                        {
                            guid: "503b455e-8d43-429d-b0ad-19fe9d43e157",
                            date_of_service: "2022-04-25",
                            datetime_of_service: "2022-04-25 00:00:00 EDT",
                            transaction_type: "CG",
                            transaction_id: 144068,
                            source_transaction_id: "2",
                            transaction_posting_date: "2021-04-20",
                            alt_transaction_description: "FINE NEEDLE ASPIRATION, RIGHT CHEST WALL",
                            department_code: "10030010328",
                            fee_schedule: "5000356",
                            technical_code: {
                                units: 1.0,
                                code: "31000093",
                                used: true,
                                automated: false,
                                sequence_number: 0,
                                evidence: []
                            },
                            modifiers: [],
                            diagnoses: [
                                {
                                    diagnosis_uid: null,
                                    diagnosis_code: "L02.91",
                                    evidence_source_uid: null,
                                    automate: false,
                                    confidence: 0.0,
                                    sequence_number: 1,
                                    type: "ICD10",
                                    evidence: [],
                                    used: true
                                }
                            ]
                        },
                        {
                            guid: "5b439630-bd6c-4050-848d-bd9845d7dc53",
                            date_of_service: "2022-04-25",
                            datetime_of_service: "2022-04-25 00:00:00 EDT",
                            transaction_type: "CG",
                            transaction_id: 144069,
                            source_transaction_id: "1",
                            transaction_posting_date: "2021-04-20",
                            alt_transaction_description: "FNA Rapid Evaluation (Professional and T",
                            department_code: "10030010328",
                            fee_schedule: "5000356",
                            technical_code: {
                                units: 1.0,
                                code: "31000092",
                                used: true,
                                automated: false,
                                sequence_number: 0,
                                evidence: []
                            },
                            modifiers: [],
                            diagnoses: [
                                {
                                    diagnosis_uid: null,
                                    diagnosis_code: "L02.91",
                                    evidence_source_uid: null,
                                    automate: false,
                                    confidence: 0.0,
                                    sequence_number: 1,
                                    type: "ICD10",
                                    evidence: [],
                                    used: true
                                }
                            ]
                        }
                    ],
                    billing_provider_type: null,
                    ordering_provider_type: null,
                    referring_provider_type: null,
                    performing_provider_type: null
                },
                {
                    type: "PROCESSED",
                    guid: "09975221-be36-4623-8ef4-6c2e75b01116",
                    patient_type: "",
                    filler_number: {
                        number: "Ede78774d3af04aa4affca7436d210306",
                        issuer: "EPIC",
                        type: "SPECIMEN_NUMBER"
                    },
                    billing_provider_name: "FOGG, PHINEAS",
                    billing_provider_number: {
                        number: "424324",
                        issuer: "EPIC",
                        type: "IDNO"
                    },
                    ordering_provider_name: null,
                    ordering_provider_number: {
                        number: null,
                        issuer: "EPIC",
                        type: "IDNO"
                    },
                    performing_provider_name: null,
                    performing_provider_number: {
                        number: null,
                        issuer: "EPIC",
                        type: "IDNO"
                    },
                    transactions: [
                        {
                            guid: "025ec5dd-410b-4cb1-a5dd-0535c8d25f7c",
                            date_of_service: "2022-04-25",
                            datetime_of_service: "2022-04-25 00:00:00 EDT",
                            transaction_type: "CG",
                            transaction_id: 144076,
                            source_transaction_id: "3",
                            transaction_posting_date: "2021-04-20",
                            alt_transaction_description: "Charge for cytology with cell block",
                            department_code: "10030010328",
                            fee_schedule: "5000356",
                            technical_code: {
                                units: 1.0,
                                code: "31000150",
                                used: true,
                                automated: false,
                                sequence_number: 0,
                                evidence: []
                            },
                            modifiers: [],
                            diagnoses: [
                                {
                                    diagnosis_uid: null,
                                    diagnosis_code: "L02.91",
                                    evidence_source_uid: null,
                                    automate: false,
                                    confidence: 0.0,
                                    sequence_number: 1,
                                    type: "ICD10",
                                    evidence: [],
                                    used: true
                                }
                            ]
                        },
                        {
                            guid: "e7fba241-9256-4a45-a757-8dd72179b3de",
                            date_of_service: "2022-04-25",
                            datetime_of_service: "2022-04-25 00:00:00 EDT",
                            transaction_type: "CG",
                            transaction_id: 144077,
                            source_transaction_id: "2",
                            transaction_posting_date: "2021-04-20",
                            alt_transaction_description: "FINE NEEDLE ASPIRATION, RIGHT CHEST WALL",
                            department_code: "10030010328",
                            fee_schedule: "5000356",
                            technical_code: {
                                units: 1.0,
                                code: "31000093",
                                used: true,
                                automated: false,
                                sequence_number: 0,
                                evidence: []
                            },
                            modifiers: [],
                            diagnoses: [
                                {
                                    diagnosis_uid: null,
                                    diagnosis_code: "L02.91",
                                    evidence_source_uid: null,
                                    automate: false,
                                    confidence: 0.0,
                                    sequence_number: 1,
                                    type: "ICD10",
                                    evidence: [],
                                    used: true
                                }
                            ]
                        },
                        {
                            guid: "45165286-a542-45ee-a558-5bb7120c07a9",
                            date_of_service: "2022-04-25",
                            datetime_of_service: "2022-04-25 00:00:00 EDT",
                            transaction_type: "CG",
                            transaction_id: 144078,
                            source_transaction_id: "1",
                            transaction_posting_date: "2021-04-20",
                            alt_transaction_description: "FNA Rapid Evaluation (Professional and T",
                            department_code: "10030010328",
                            fee_schedule: "5000356",
                            technical_code: {
                                units: 1.0,
                                code: "31000092",
                                used: true,
                                automated: false,
                                sequence_number: 0,
                                evidence: []
                            },
                            modifiers: [],
                            diagnoses: [
                                {
                                    diagnosis_uid: null,
                                    diagnosis_code: "L02.91",
                                    evidence_source_uid: null,
                                    automate: false,
                                    confidence: 0.0,
                                    sequence_number: 1,
                                    type: "ICD10",
                                    evidence: [],
                                    used: true
                                }
                            ]
                        }
                    ],
                    billing_provider_type: null,
                    ordering_provider_type: null,
                    referring_provider_type: null,
                    performing_provider_type: null
                },
                {
                    type: "SUBMITTED",
                    guid: "3ba7eaeb-2da4-4104-994a-c0d2eb5b1448",
                    patient_type: "",
                    filler_number: {
                        number: "Ede78774d3af04aa4affca7436d210306",
                        issuer: "EPIC",
                        type: "SPECIMEN_NUMBER"
                    },
                    billing_provider_name: "FOGG, PHINEAS",
                    billing_provider_number: {
                        number: "424324",
                        issuer: "EPIC",
                        type: "IDNO"
                    },
                    ordering_provider_name: null,
                    ordering_provider_number: {
                        number: null,
                        issuer: "EPIC",
                        type: "IDNO"
                    },
                    performing_provider_name: null,
                    performing_provider_number: {
                        number: null,
                        issuer: "EPIC",
                        type: "IDNO"
                    },
                    transactions: [
                        {
                            guid: "16b198bf-e2fd-4fa2-b19b-7628e004294e",
                            type: "HB",
                            date_of_service: "2022-04-25",
                            datetime_of_service: "2022-04-25 00:00:00 EDT",
                            transaction_type: "CG",
                            transaction_id: 144084,
                            source_transaction_id: "1",
                            transaction_posting_date: "2021-04-20",
                            alt_transaction_description: "FNA Rapid Evaluation (Professional and T",
                            department_code: "10030010328",
                            fee_schedule: "5000356",
                            technical_code: {
                                units: 1.0,
                                code: "31000092",
                                used: true,
                                automated: false,
                                sequence_number: 0,
                                evidence: []
                            },
                            modifiers: [],
                            diagnoses: [
                                {
                                    diagnosis_uid: null,
                                    diagnosis_code: "L02.91",
                                    evidence_source_uid: null,
                                    automate: false,
                                    confidence: 0.0,
                                    sequence_number: 1,
                                    type: "ICD10",
                                    evidence: [],
                                    used: true
                                }
                            ]
                        },
                        {
                            guid: "3cc5d222-7588-408b-9191-1f96fcdd2d93",
                            type: "HB",
                            date_of_service: "2022-04-25",
                            datetime_of_service: "2022-04-25 00:00:00 EDT",
                            transaction_type: "CG",
                            transaction_id: 144082,
                            source_transaction_id: "3",
                            transaction_posting_date: "2021-04-20",
                            alt_transaction_description: "Charge for cytology with cell block",
                            department_code: "10030010328",
                            fee_schedule: "5000356",
                            technical_code: {
                                units: 1.0,
                                code: "31000150",
                                used: true,
                                automated: false,
                                sequence_number: 0,
                                evidence: []
                            },
                            modifiers: [],
                            diagnoses: [
                                {
                                    diagnosis_uid: null,
                                    diagnosis_code: "L02.91",
                                    evidence_source_uid: null,
                                    automate: false,
                                    confidence: 0.0,
                                    sequence_number: 1,
                                    type: "ICD10",
                                    evidence: [],
                                    used: true
                                }
                            ]
                        },
                        {
                            guid: "114d63ce-781c-4f73-aebe-e7a46f642915",
                            type: "HB",
                            date_of_service: "2022-04-25",
                            datetime_of_service: "2022-04-25 00:00:00 EDT",
                            transaction_type: "CG",
                            transaction_id: 144083,
                            source_transaction_id: "2",
                            transaction_posting_date: "2021-04-20",
                            alt_transaction_description: "FINE NEEDLE ASPIRATION, RIGHT CHEST WALL",
                            department_code: "10030010328",
                            fee_schedule: "5000356",
                            technical_code: {
                                units: 1.0,
                                code: "31000093",
                                used: true,
                                automated: false,
                                sequence_number: 0,
                                evidence: []
                            },
                            modifiers: [],
                            diagnoses: [
                                {
                                    diagnosis_uid: null,
                                    diagnosis_code: "L02.91",
                                    evidence_source_uid: null,
                                    automate: false,
                                    confidence: 0.0,
                                    sequence_number: 1,
                                    type: "ICD10",
                                    evidence: [],
                                    used: true
                                }
                            ]
                        }
                    ],
                    billing_provider_type: null,
                    ordering_provider_type: null,
                    referring_provider_type: null,
                    performing_provider_type: null
                }
            ],
            artifacts: [],
            transactions: [
                {
                    patient_type: "",
                    filler_number: {
                        number: "Ede78774d3af04aa4affca7436d210306",
                        issuer: "EPIC",
                        type: "SPECIMEN_NUMBER"
                    },
                    ordering_provider_name: null,
                    ordering_provider_number: {
                        number: null,
                        issuer: "EPIC",
                        type: "IDNO"
                    },
                    performing_provider_name: null,
                    performing_provider_number: {
                        number: null,
                        issuer: "EPIC",
                        type: "IDNO"
                    },
                    guid: "7d2716ae-2f31-4f68-9aa3-2414da138a56",
                    type: "HB",
                    date_of_service: "2022-04-25",
                    datetime_of_service: "2022-04-25 00:00:00 EDT",
                    transaction_type: "CG",
                    transaction_id: 143944,
                    source_transaction_id: "1",
                    transaction_posting_date: "2021-04-20",
                    alt_transaction_description: "FNA Rapid Evaluation (Professional and T",
                    department_code: "10030010328",
                    fee_schedule: "5000356",
                    technical_code: {
                        units: 1.0,
                        code: "31000092",
                        used: true,
                        automated: false,
                        sequence_number: 0,
                        evidence: []
                    },
                    modifiers: [],
                    diagnoses: [
                        {
                            diagnosis_uid: null,
                            diagnosis_code: "L02.91",
                            evidence_source_uid: null,
                            automate: false,
                            confidence: 0.0,
                            sequence_number: 1,
                            type: "ICD10",
                            evidence: [],
                            used: true
                        }
                    ]
                },
                {
                    patient_type: "",
                    filler_number: {
                        number: "Ede78774d3af04aa4affca7436d210306",
                        issuer: "EPIC",
                        type: "SPECIMEN_NUMBER"
                    },
                    ordering_provider_name: null,
                    ordering_provider_number: {
                        number: null,
                        issuer: "EPIC",
                        type: "IDNO"
                    },
                    performing_provider_name: null,
                    performing_provider_number: {
                        number: null,
                        issuer: "EPIC",
                        type: "IDNO"
                    },
                    guid: "cfb582e5-aa51-460d-853f-070db5ab44a1",
                    type: "HB",
                    date_of_service: "2022-04-25",
                    datetime_of_service: "2022-04-25 00:00:00 EDT",
                    transaction_type: "CG",
                    transaction_id: 143943,
                    source_transaction_id: "2",
                    transaction_posting_date: "2021-04-20",
                    alt_transaction_description: "FINE NEEDLE ASPIRATION, RIGHT CHEST WALL",
                    department_code: "10030010328",
                    fee_schedule: "5000356",
                    technical_code: {
                        units: 1.0,
                        code: "31000093",
                        used: true,
                        automated: false,
                        sequence_number: 0,
                        evidence: []
                    },
                    modifiers: [],
                    diagnoses: [
                        {
                            diagnosis_uid: null,
                            diagnosis_code: "L02.91",
                            evidence_source_uid: null,
                            automate: false,
                            confidence: 0.0,
                            sequence_number: 1,
                            type: "ICD10",
                            evidence: [],
                            used: true
                        }
                    ]
                },
                {
                    patient_type: "",
                    filler_number: {
                        number: "Ede78774d3af04aa4affca7436d210306",
                        issuer: "EPIC",
                        type: "SPECIMEN_NUMBER"
                    },
                    ordering_provider_name: null,
                    ordering_provider_number: {
                        number: null,
                        issuer: "EPIC",
                        type: "IDNO"
                    },
                    performing_provider_name: null,
                    performing_provider_number: {
                        number: null,
                        issuer: "EPIC",
                        type: "IDNO"
                    },
                    guid: "3e60932d-797c-4236-aa61-d620cb604d5b",
                    type: "HB",
                    date_of_service: "2022-04-25",
                    datetime_of_service: "2022-04-25 00:00:00 EDT",
                    transaction_type: "CG",
                    transaction_id: 143942,
                    source_transaction_id: "3",
                    transaction_posting_date: "2021-04-20",
                    alt_transaction_description: "Charge for cytology with cell block",
                    department_code: "10030010328",
                    fee_schedule: "5000356",
                    technical_code: {
                        units: 1.0,
                        code: "31000150",
                        used: true,
                        automated: false,
                        sequence_number: 0,
                        evidence: []
                    },
                    modifiers: [],
                    diagnoses: [
                        {
                            diagnosis_uid: null,
                            diagnosis_code: "L02.91",
                            evidence_source_uid: null,
                            automate: false,
                            confidence: 0.0,
                            sequence_number: 1,
                            type: "ICD10",
                            evidence: [],
                            used: true
                        }
                    ]
                }
            ],
            notes: [],
            case_created_datetime: "2022-04-24 23:57:13 EDT",
            process_instance_created_datetime: "2022-04-24 23:57:13 EDT",
            exclusion_datetime: null,
            prediction_start_datetime: null,
            added_to_batch_datetime: null,
            response_from_batch_datetime: null,
            prediction_end_datetime: null,
            automation_decision_datetime: "2022-04-25 00:09:10 EDT",
            send_to_coder_datetime: null,
            received_from_coder_datetime: null,
            send_to_billing_datetime: "2022-04-25 00:09:10 EDT",
            process_instance_completed_datetime: "2022-04-25 00:09:10 EDT",
            case_completed_datetime: "2022-04-25 00:09:10 EDT",
            claims_edit_indicator: null,
            cci_edit_indicator: null,
            claims_editor_payer_id: null,
            claims_editor_payer_name: null,
            claims_editor_issues: null,
            cci_editor_issues: null,
            customer_automation_decision: null,
            post_manual_charges: null,
            prevent_billing_indicator: false,
            prevent_send_to_coder_indicator: true,
            automated_indicator: false,
            route_to_predict: false,
            route_to_billing: false,
            route_to_qa: false,
            route_to_coder: true,
            route_to_claims_editor: null,
            pre_prediction_process_reason: "Invalid Case:Missing Data",
            post_prediction_process_reason: "Do Not Automate:Codes Not Linked",
            automate_decision_reason: "RULE",
            termination_indicator: false,
            study_indicator: false,
            automation_eligible: true,
            can_automate: false,
            decoration: '{"Invalid Case":["Missing Data"],"Incomplete Case":["Missing ORU"],"TEST ONLY: Health System - PHS":["PHS Health System"],"TEST ONLY: Brigham & Women\'s Hospital - BWH":["BWH Tenant"],"Do Not Automate":["Codes Not Linked"]}',
            decorators: [
                {
                    category: "Invalid Case",
                    subcategory: "Missing Data"
                },
                {
                    category: "Do Not Automate",
                    subcategory: "Codes Not Linked"
                },
                {
                    category: "TEST ONLY: Brigham & Women's Hospital - BWH",
                    subcategory: "BWH Tenant"
                },
                {
                    category: "TEST ONLY: Health System - PHS",
                    subcategory: "PHS Health System"
                },
                {
                    category: "Incomplete Case",
                    subcategory: "Missing ORU"
                }
            ],
            hold_billing: false,
            hold_billing_reason: null,
            release_billing_reason: null,
            release_to_billing: true,
            release_to_coder: false,
            rules: '{"Invalid Case":[{"decoration_category":"Invalid Case","decoration_subcategory":"Missing Data","decoration_description":"Missing Notes"},{"decoration_category":"Invalid Case","decoration_subcategory":"Missing Data","decoration_description":"Charges or Results Not Received"}],"Incomplete Case":[{"decoration_category":"Incomplete Case","decoration_subcategory":"Missing ORU","decoration_description":"Missing ORU"}],"TEST ONLY: Health System - PHS":[{"decoration_category":"TEST ONLY: Health System - PHS","decoration_subcategory":"PHS Health System","decoration_description":"PHS Health System"}],"TEST ONLY: Brigham & Women\'s Hospital - BWH":[{"decoration_category":"TEST ONLY: Brigham & Women\'s Hospital - BWH","decoration_subcategory":"BWH Tenant","decoration_description":"BWH Tenant"}],"Do Not Automate":[{"decoration_category":"Do Not Automate","decoration_subcategory":"Codes Not Linked","decoration_description":"Codes Not Linked"}]}',
            rule_evaluation_results: [],
            process: null,
            phase: "TESTING",
            algorithm: "carson",
            environment: "qa1",
            provenance: "CmxCaseBuilder",
            ml_function: "pathology-prediction",
            ml_version: "1.0.3",
            bpm_process_id: "ca5aeb84-c44b-11ec-9459-d6aa1805fef3",
            prediction_job_id: null,
            case_s3_uri: null,
            batch_s3_uri: null,
            prediction_s3_uri: null,
            external_id: null,
            billing_export_id: 38843,
            cac_export_id: null,
            billing_group_id: null,
            case_event_id: null,
            export_group_id: null,
            resubmit_date: "2022-04-24 23:57:13 EDT",
            submitter_process: null,
            submitted_primary_clinical_identifier: null,
            send_to_coder_orchestrator: null,
            coder_orchestrator_destination: null,
            feedback_loop_enabled: null,
            rendering_provider_specialty: null,
            rendering_provider_name: null,
            rendering_provider_number: {
                number: null,
                issuer: null,
                type: null
            }
        }
    ]
};
//# sourceMappingURL=path-case.js.map